module.exports = __webpack_public_path__ + "img/256px-Vue.js_Logo_2.svg.2d53d034.png";